import React, { useState } from "react";
import { useAuth } from "@/context/Auth";
import ProfileForm from "@/components/ProfileForm";

export default function CompanyProfile() {
  const { user, refresh } = useAuth();
  const [initial] = useState(user);
  return (
    <div>
      <h1 className="font-head text-2xl font-extrabold text-slate-900">Company Profile</h1>
      <p className="mt-1 text-sm text-slate-500">Keep your business details up to date.</p>
      <div className="mt-5 rounded-2xl border border-slate-200 bg-white p-6">
        <ProfileForm initial={initial} onSaved={() => refresh()} />
      </div>
    </div>
  );
}
